var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 33,
    viewBox: "0 0 20 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99701 0.5L9.78322 1.22902V22.3834L9.99701 22.5975L19.7852 16.7931L9.99701 0.5Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99709 0.5L0.208954 16.7931L9.99709 22.5976V12.3299V0.5Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 24.4567L9.87692 24.604V32.1397L9.9974 32.4928L19.7914 18.6553L9.9974 24.4567Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99709 32.4928V24.4567L0.208954 18.6553L9.99709 32.4928Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99606 22.5976L19.784 16.7933L9.99606 12.3301V22.5976Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.20903 16.7931L9.99701 22.5974V12.3298L0.20903 16.7931Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5821,
    height: 32,
    fill: "white",
    transform: "translate(0.208954 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEth);
export default __webpack_public_path__ + "static/media/logo_eth.1ae0e0e7fbc0d9b3aa3211802002336f.svg";
export { ForwardRef as ReactComponent };